import {environment} from '../../../environments/environment.prod';
import { Injectable } from "@angular/core";

@Injectable()
export class BaseUrls {
    private baseUrl = environment.API_URL;
    private prefix = environment.PREFIX;
    public getUrl() {
        return this.baseUrl + this.prefix;
    }

    public getBaseUrl() {
        return this.baseUrl;
    }
}
